<script setup>
</script>

<template>
  <div>
    <nav>
      <ul>
        <li><router-link to="/" class="nav-link">Home</router-link></li>
        <li><router-link to="/contact" class="nav-link">Contact</router-link></li>
        <!-- Add more links as needed -->
      </ul>
    </nav>
  </div>
</template>

<style scoped>
nav {
  background-color: #007bff;
  padding: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

nav ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

nav ul li {
  display: inline;
  margin-right: 10px;
}

nav ul li a {
  color: white;
  text-decoration: none;
  padding: 8px 12px;
  border-radius: 4px;
}

nav ul li a:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.nav-link {
  transition: background-color 0.3s;
}
</style>
